import React, { useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { MasterMessage } from '../../../masters/masterMessages';
import { useNavigate } from 'react-router-dom';
import { CASEMANAGERLIST, HOME } from '../../../routes/paths';
import Swal from 'sweetalert2';
import ListView from '../../components/views/listView';
import ModalLoading from '../../components/general/loading/modalLoading';
import DropZoneField from '../../components/general/fields/dropzoneField';
import Grid from '@mui/material/Grid';
import { asyncPostBulkLoad } from '../../../services/caseManager.service';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';

const BulkLoad = () => {
    const navigate = useNavigate();
    const { titleList, messageError, titleModalLoading, messageModalLoading } =
        MasterMessage.bulkLoad;
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<any>([]);

    const handleClick = () => {
        if (files.length > 0) {
            setLoading(true);
            asyncPostBulkLoad(files[0])
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setLoading(false);
                        Swal.fire({
                            title: 'Carga Exitosa',
                            text: `Se cargaron ${body.items.length} registros exitosamente`,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            allowOutsideClick: false,
                            customClass: 'swal-wide-class',
                        }).then((response) => {
                            if (response.isConfirmed) {
                                navigate(CASEMANAGERLIST);
                            }
                        });
                    } else {
                        Swal.fire({
                            title: 'Error Carga',
                            text: messageError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    }
                })
                .finally(() => setLoading(false));
        } else {
            SwalCustomClass.fire({
                text: 'Debes seleccionar algún archivo',
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };

    return (
        <>
            <ListView
                title={titleList}
                titleButtonAdd={'Cargar'}
                onClickAdd={() => handleClick()}
                startIconButtonAdd={<FileUploadIcon color="secondary" />}
                onClickBack={() => navigate(HOME)}
                disableDataGrid={true}
            />
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} mt={3} sx={{ minWidth: 300 }}>
                    <DropZoneField
                        name="Cargue Masivo"
                        maxFiles={1}
                        accept=".xlsx"
                        onChange={(value) => setFiles(value)}
                    />
                </Grid>
            </Grid>
            {loading ? (
                <ModalLoading
                    open={loading}
                    title={titleModalLoading}
                    message={messageModalLoading}
                />
            ) : null}
        </>
    );
};

export default BulkLoad;
